import React from 'react';
import { Box, Button, Typography, Grid, Chip } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {useNavigate} from "react-router";



export function DayViewDetail({ appointments, date ,setOpenAppointmentDetail }) {
    const navigate = useNavigate()

    const handleRedirect = (url) => {
        navigate(url)
    }
  return (
      <Grid container spacing={2}>
        {appointments.length > 0 ? (
            appointments.map((appointment, index) => (
                <Grid item lg={2.4} md={4} sm={6} xs={12} key={appointment.id}  sx={{cursor:"pointer"}}  onClick={() => setOpenAppointmentDetail(appointment.id)}>
                  <Box
                      sx={{
                        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 4px',
                        px: 2,
                        py: 3,
                        borderLeft: `5px solid ${appointment.status_color}`,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                  >
                    <Typography
                        sx={{
                          fontSize: '1.25rem',
                          lineHeight: 1.6,
                          letterSpacing: '0.0075em',
                          fontWeight: 700,
                        }}
                    >
                      {appointment.customer.name}
                    </Typography>

                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                      <AccessTimeIcon fontSize="small" sx={{ mr: 0.5, color: 'rgba(0, 0, 0, 0.6)' }} />
                      <Typography
                          sx={{
                            fontSize: '0.875rem',
                            color: 'rgba(0, 0, 0, 0.6)',
                          }}
                      >
                        {appointment.start_time} - {appointment.end_time}
                      </Typography>
                    </Box>

                    <Box sx={{ mt: 2 }}>
                      {appointment.services.map((service, i) => (
                          <Chip
                              key={i}
                              label={service}
                              size="small"
                              sx={{
                                mr: 1,
                                mb: 1,
                                backgroundColor: appointment.opacity_color,
                                color: 'common.white'
                              }}
                          />
                      ))}
                    </Box>

                    <Button
                        sx={{
                          backgroundColor: `${appointment.opacity_color}`,
                          color: appointment.status_color,
                          padding: '6px 12px',
                          borderRadius: '4px',
                          textAlign: 'center',
                          fontWeight: 500,
                          fontSize: '0.875rem',
                          width: '100%',
                          mt: 2,
                          textTransform: 'capitalize'
                        }}
                    >
                      {appointment.type}
                    </Button>

                    {appointment.notes && (
                        <Typography
                            sx={{
                              color: 'rgba(0, 0, 0, 0.6)',
                              mt: 1,
                              fontSize: '0.875rem',
                              lineClamp: 2,
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden'
                            }}
                        >
                          {appointment.notes}
                        </Typography>
                    )}
                      {appointment?.staff_name && (
                          <Typography
                              sx={{
                                  color: appointment?.staff_color,
                                  mt: 1,
                                  fontSize: '0.875rem',
                                  lineClamp: 2,
                                  display: '-webkit-box',
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: 'vertical',
                                  overflow: 'hidden'
                              }}
                          >
                              {appointment.staff_name}
                          </Typography>
                      )}

                    <Chip
                        label={appointment.payment_status}
                        size="small"
                        sx={{
                          mt: 2,
                          alignSelf: 'flex-start',
                          backgroundColor: appointment.payment_status === 'Paid' ? '#e8f5e9' : '#ffebee',
                          color: appointment.payment_status === 'Paid' ? '#2e7d32' : '#d32f2f'
                        }}
                    />
                  </Box>
                </Grid>
            ))
        ) : (
            <Grid item xs={12}>
              <Button
                  sx={{
                    background: '#19A2FF',
                    px: '24px',
                    border: '1px solid #19A2FF',
                    color: '#fff',
                    marginRight: 2,
                    marginBottom: { xl: 0, lg: 1, md: 2, sm: 2, xs: 2 },
                    '@media (min-width: 700px) and (max-width: 1199px)': { marginRight: '0px' },
                    "&:hover": {
                      background: '#fff',
                      color: '#19A2FF',
                    }
                  }}
                  onClick={() => {
                       handleRedirect("/crm/add-appointment"); // Uncomment if you have this function
                  }}
              >
                Add Appointment
              </Button>
            </Grid>
        )}
      </Grid>
  );
}